import React from 'react'
import { Card, Col, Container, ListGroup, Row } from 'react-bootstrap'
import data from "../../../data/PlanData.json"

function Plans() {
    return (
        <Container>
            <Row className="justify-content-center home-plan-row">
                <Col className='home-plan-col' > <h2> Our Packages </h2> </Col>
            </Row>
            <Row className='plan_card_row'>
                {
                    data.map((d) => (
                        <Col xl={3} md={6} xs={12} sm={12} className="mt-3 plan_card ">
                            <Card>
                                {/* <Card.Body> */}
                                <Card.Title className='plan_card_title'>{d.title}</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted plan_card_subtitle"> {d.amount} </Card.Subtitle>
                                <ListGroup variant="flush" className='text-center' >
                                    <ListGroup.Item className="text-muted">{d.text}</ListGroup.Item>
                                    <ListGroup.Item className="text-muted">{d.textOne}</ListGroup.Item>
                                    <ListGroup.Item className="text-muted">{d.textTwo}</ListGroup.Item>
                                    <ListGroup.Item className="text-muted">{d.textThree}</ListGroup.Item>
                                    <ListGroup.Item className="text-muted">{d.textFour}</ListGroup.Item>
                                </ListGroup>
                                <Card.Link href="#" className='plan_card_link'>
                                    <a href={d.quoteData} target="_blank" className='plan_card_link_text' style={{ backgroundColor: d.bgColor }}>Get Quote</a>
                                </Card.Link>
                                {/* </Card.Body> */}
                            </Card>
                        </Col>
                    ))
                }

            </Row>
        </Container>

    )
}

export default Plans